/* MTH custom select — progressively replaces native <select> menus (which pop
   the OS-native "Apple" UI) with a built-in dropdown. Keeps the real <select>
   in the DOM (hidden) for form submission + Dawn's facet JS; the custom UI just
   proxies value changes to it. Targets the collection/search sort + facet
   selects; re-enhances after Dawn re-renders them via AJAX. */
(function () {
  var TARGET = 'select.facet-filters__sort, .facets select, select.mth-enhance';

  function enhance(select) {
    if (select.dataset.mthEnhanced || select.multiple) return;
    select.dataset.mthEnhanced = '1';

    var wrap = document.createElement('div');
    wrap.className = 'mth-select';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mth-select__button';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.className = 'mth-select__label';
    label.textContent = currentText(select);
    btn.appendChild(label);
    btn.insertAdjacentHTML('beforeend', '<span class="mth-select__caret" aria-hidden="true"></span>');

    var panel = document.createElement('div');
    panel.className = 'mth-select__panel';
    panel.setAttribute('role', 'listbox');

    Array.prototype.forEach.call(select.options, function (opt, i) {
      var o = document.createElement('button');
      o.type = 'button';
      o.className = 'mth-select__option';
      o.textContent = opt.text;
      o.dataset.value = opt.value;
      o.setAttribute('role', 'option');
      if (i === select.selectedIndex) o.setAttribute('aria-selected', 'true');
      o.addEventListener('click', function () {
        select.value = opt.value;
        label.textContent = opt.text;
        panel.querySelectorAll('.mth-select__option').forEach(function (x) { x.removeAttribute('aria-selected'); });
        o.setAttribute('aria-selected', 'true');
        close();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      panel.appendChild(o);
    });

    wrap.appendChild(btn);
    wrap.appendChild(panel);

    // Dawn ships its own caret (the inline `icon-caret.svg`) as a sibling of the
    // native <select> inside the `.select` wrapper. Now that our custom button
    // carries its own `.mth-select__caret`, that leftover caret would sit on top
    // of ours — the doubled/overlapping chevron on the sort + filter dropdowns
    // (Brandon 2026-07-06). Hide any stray caret left in the original wrapper.
    var origWrap = wrap.parentNode;
    if (origWrap) {
      Array.prototype.forEach.call(
        origWrap.querySelectorAll(':scope > .icon-caret, :scope > .svg-wrapper'),
        function (el) { el.style.display = 'none'; }
      );
    }

    function currentText(s) {
      return s.options[s.selectedIndex] ? s.options[s.selectedIndex].text : '';
    }
    function outside(e) {
      // Self-heal: if Dawn AJAX-replaced the facets while this was open, the
      // wrap is detached — drop the orphaned document listeners.
      if (!document.contains(wrap)) { close(); return; }
      if (!wrap.contains(e.target)) close();
    }
    function onkey(e) { if (e.key === 'Escape') { close(); btn.focus(); } }
    function open() {
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', outside);
      document.addEventListener('keydown', onkey);
    }
    function close() {
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', outside);
      document.removeEventListener('keydown', onkey);
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      wrap.classList.contains('is-open') ? close() : open();
    });
    select.addEventListener('change', function () { label.textContent = currentText(select); });
  }

  function enhanceAll(root) {
    (root || document).querySelectorAll(TARGET).forEach(enhance);
  }

  function init() {
    enhanceAll();
    // Only observe on pages that actually have sort/filter selects
    // (collection/search) and scope the observer to the main content — not the
    // whole document — so unrelated mutations (cart drawer, predictive search,
    // sticky header, scroll animations) don't trigger full re-scans.
    if (!document.querySelector(TARGET) && !document.querySelector('.facets')) return;
    var scope = document.getElementById('MainContent') || document.body;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; enhanceAll(scope); });
    }).observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
